<template>
  <div :class="['menusBox', isDark ? 'menusBoxDark' : '']">
    <div class="logoBox">
      <img class="logo" src="../../../../assets/chatImg/logo.png" alt="">
    </div>
    <div class="menuList">
      <div
        :class="['menu', item.componentName === comname ? 'chooseMenu' : '']"
        v-for="(item, index) in menuList"
        :key="item.icon"
        @click="changeComponentName(item.componentName)"
      >
        <i :class="item.icon"></i>
        <!-- <span v-if="item.unread" class="unread"></span> -->
      </div>
    </div>
    <div class="themeBox" @click="changeDark">
      <i class="ti-palette"></i>
    </div>
  </div>
  <!-- <div class="mobileMenus"></div> -->
</template>

<script>
import {mapMutations, mapState, mapGetters} from 'vuex';
export default {
  name: 'menus',
  components: {},
  props: {
  },
  data() {
    return {
      menuList: [
        {
          icon: 'ti-comments',
          unread: true,
          componentName: 'Chats',
        },
        {
          icon: 'ti-comment-alt',
          unread: false,
          componentName: 'ChatHistory',
        },
        {
          icon: 'ti-heart',
          unread: false,
          componentName: 'Favorite',
        },
        {
          icon: 'ti-credit-card',
          unread: false,
          componentName: 'Quota',
        },
      ]
    }
  },
  computed: {
    ...mapState('comAbout', {comname: 'componentName', isDark: 'isDark'}),
  },
  watch: {
  },
  created() { },
  mounted() {
    const userIsDark = JSON.parse(localStorage.getItem('comVuex'));
    this.changeIsDark(userIsDark.isDark);
  },
  methods: {
    ...mapMutations('comAbout', ['changeComponentName', 'changeIsDark']),
    changeDark() {
      this.changeIsDark(!this.isDark);
    },
  }
}
</script>

<style scoped lang="less">
.menusBox {
  background: #2f80ec;
  width: 100px;
  border-radius: 10px;
  height: 100vh;
  color: white;

  .logoBox {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    .logo {
      width: 60px;
      height: 60px;
    }
  }

  .menuList {
    width: 100px;
    height: calc(100vh - 120px - 75px);

    .menu {
      margin: 10px 20px;
      width: 60px;
      height: 55px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 7px;
      position: relative;
      cursor: pointer;

      // background: #1a73e9;
      i {
        font-size: 20px;
      }
      .unread {
        background: #ffc107;
        width: 7px;
        height: 7px;
        position: absolute;
        border-radius: 50%;
        top: 10px;
        right: 10px;
      }
    }

    .chooseMenu {
      background: #1a73e9;
    }
  }

  .themeBox {
    width: 100px;
    height: 55px;
    padding: 15px 0;
    margin: 10px auto;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    i {
      font-size: 20px;
    }
  }
}
.menusBoxDark {
  background: #293145;
  // border-right: 2px solid #293145;
}

@media screen and (max-width: 990px) {
  .menusBox {
    height: 63px;
    width: 100vw;
    border-radius: 0;

    .menuList {
      height: 100%;
      width: auto;
      max-width: 720px;
      margin: auto;
      display: flex;
      justify-content: space-between;
      .menu {
        margin: 4px 15px;
      }
    }

    .logoBox {
      display: none;
    }
    .themeBox {
      display: none;
    }
  }
}
</style>
